import Vue from "vue";

const state = {
	systemmessages_options: {
		page: 1,
		itemsPerPage: null,
		sortBy: ["created_at"],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		mustSort: false,
		multiSort: false,
		search: null,
		type: null,
	},
	systemmessages: {},
	_systemmessages_loading: 0,
	systemmessages_toread: [],
};

const getters = {
	getSystemMessagesOptions: (state) => state.systemmessages_options,
	getSystemMessages: (state) => state.systemmessages,
	getSystemMessagesToRead: (state) => state.systemmessages_toread,
	systemmessages_loading: (state) => state._systemmessages_loading !== 0,
};

const actions = {
	fetchSystemMessages({ commit, dispatch }) {
		commit("START_SYSTEMMESSAGES_LOADING");
		axios
			.get("/api/system-messages/all", { params: state.systemmessages_options })
			.then((res) => {
				commit("setSystemMessages", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_SYSTEMMESSAGES_LOADING");
			});
	},
	fetchSystemMessagesToRead({ commit, dispatch }) {
		commit("START_SYSTEMMESSAGES_LOADING");
		axios
			.get("/api/system-messages/to-be-read")
			.then((res) => {
				commit("setSystemMessagesToRead", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_SYSTEMMESSAGES_LOADING");
			});
	},
	closeSystemMessage({ commit, dispatch }, id) {
		commit("START_SYSTEMMESSAGES_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/system-messages/" + id + "/close")
				.then((res) => {
					dispatch("fetchSystemMessagesToRead");
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_SYSTEMMESSAGES_LOADING");
				});
		});
	},
};

const mutations = {
	setSystemMessagesOptions(state, value) {
		Vue.set(state, "systemmessages_options", value);
	},
	setSystemMessages(state, data) {
		Vue.set(state, "systemmessages", data);
	},
	setSystemMessagesToRead(state, data) {
		Vue.set(state, "systemmessages_toread", data);
	},
	START_SYSTEMMESSAGES_LOADING(state) {
		state._systemmessages_loading++;
	},
	STOP_SYSTEMMESSAGES_LOADING(state) {
		state._systemmessages_loading--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
